export const EventQuestionType = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE',
  TEXT: 'TEXT',
  RATING: 'RATING',
};

export const eventQuestionTypes = [
  EventQuestionType.SINGLE,
  EventQuestionType.MULTIPLE,
  EventQuestionType.TEXT,
  EventQuestionType.RATING,
];
